import { SiloAsset } from 'app/queries/decoratedSilo';
import { FC } from 'react';
import { useActionFormContext } from './ActionForm.context';
import { BigNumberWithDecimals } from '@silo/types';
import { asDecimal } from '@silo/utils';
import { HelpTooltip } from '@silo/ui';

interface LiquidityTooltipProps {
  action: Action;
}

type Action = 'borrow' | 'withdraw';

export const LiquidityTooltip: FC<LiquidityTooltipProps> = ({ action }) => {
  const { selectedAsset, maxAmount } = useActionFormContext();
  const showLiquidityTooltip = maxAmount.type === 'liquidity';

  if (!showLiquidityTooltip) return <></>;

  return <RawLiquidityTooltip maxAmount={maxAmount.value} selectedAsset={selectedAsset} action={action} />;
};

interface RawLiquidityTooltipProps {
  maxAmount: BigNumberWithDecimals;
  selectedAsset: SiloAsset;
  action: Action;
}

export const RawLiquidityTooltip: FC<RawLiquidityTooltipProps> = ({ maxAmount, selectedAsset, action }) => {
  const getAvailableCopy = () => {
    if (maxAmount.bigNumber.isZero()) {
      return `no ${selectedAsset.symbol}`;
    }

    return `only ${asDecimal(maxAmount)} ${selectedAsset.symbol}`;
  };

  return (
    <HelpTooltip placement="bottom">
      There is {getAvailableCopy()} in the silo available to {action}.
    </HelpTooltip>
  );
};
